{
  "about": {
    "paragraph": "Estamos comprometidos a abordar los desafíos de la ley AGEC e informar a nuestros clientes sobre el origen y las cualidades ambientales de nuestros productos.",
    "title": "Acerca de"
  },
  "lastUpdate": "Fecha de última actualización : ",
  "loading": {
    "dataPending": "está recopilando actualmente esta información",
    "pendingLocation": "Ubicación pendiente"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Fabricación de prendas",
    "FOOTWEAR_FINISHING": "Acabado de calzado",
    "FOOTWEAR_STITCHING": "Costura de calzado",
    "FOOTWEAR_ASSEMBLING": "Ensamblaje de calzado",
    "FABRIC_WEAVING_OR_KNITTING": "Tejido o tricotado de tela",
    "FABRIC_DYEING_PRINTING": "Teñido o estampado de tela",
    "YARN_PROVIDER": "Proveedor de hilo",
    "YARN_DYEING_PRINTING": "Teñido o estampado de hilo",
    "LEATHER_TANNING": "Curtido del cuero",
    "LEATHER_DYEING_PRINTING": "Teñido o estampado del cuero",
    "ACCESSORY_PROVIDER": "Proveedor de accesorios",
    "YARN_MATERIAL_PRODUCTION": "Producción de material de hilo",
    "FABRIC_SPINNING": "Hilado de tela",
    "FABRIC_MATERIAL_PRODUCTION": "Producción de material de tela",
    "LEATHER_MATERIAL_PRODUCTION": "Producción de material de cuero",
    "LEATHER_FARM": "Granja de cría",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Proveedor de materia prima de accesorios",
    "COATING": "Recubrimiento"
  },
  "other": {
    "microplastics_bold": "libera microplásticos ",
    "paragraph1": "Este producto contiene ",
    "paragraph1_100": "Este producto contiene 100% de materiales reciclados.",
    "paragraph2_1": "Este producto ",
    "paragraph2_2": "  al medio ambiente durante el lavado: ",
    "paragraph2_3": "por masa del producto está compuesto por fibras sintéticas.",
    "paragraph3": "Información sobre la posible presencia de sustancias peligrosas en la aplicación: ",
    "recycled_matertials_bold": "al menos {{percent}}% de materiales reciclados.",
    "recycled_matertials_bold_50": "más del 50% ",
    "title": "Otras cualidades y características ambientales"
  },
  "packaging": {
    "recyclable": "Reciclable: El embalaje es reciclable.",
    "recycled": "Materiales reciclados: El embalaje contiene al menos {{percent}}% de materiales reciclados.",
    "recycled_100": "Materiales reciclados: El embalaje contiene 100% de materiales reciclados.",
    "title": "Cualidades y características ambientales del embalaje"
  },
  "title": "Ficha de producto sobre cualidades o características ambientales",
  "traceability": {
    "paragraph": "Esto se refiere al origen de su producto en sus tres primeras etapas de producción, desde su creación hasta el tejido y el teñido de su material principal.",
    "title": "Trazabilidad del producto"
  },
  "ecoScore": {
    "title": "EcoScore",
    "b2b": "Costo ambiental : {{cost}} puntos de impacto"
  }
}
